import $ from 'jquery';
import 'owl.carousel';


$(document).ready(function() {
    $('.js-hero-text-slider').owlCarousel({
        items: 1,
        mouseDrag: false,
        loop: true,
        dots: false,
        nav: true,
        navContainerClass: 'hero-text-slider__nav owl-nav',
        navClass: ['hero-text-slider__prev owl-prev','hero-text-slider__next owl-next'],
        navText: ['<svg class="icon icon-arrow-left"><use xlink:href="img/sprite.svg#icon-arrow-left"></use></svg>',
            '<svg class="icon icon-arrow-right"><use xlink:href="img/sprite.svg#icon-arrow-right"></use></svg>']
    });

});